import { createStyles } from '@material-ui/core';

const styles = createStyles({
  header: {
    padding: '0 0.7143rem'
  },
  noPackagesAvailable: {
    padding: '2rem 0',
    fontSize: '1.786rem',
    fontWeight: 700,

    '@media(max-width:768px)': {
      fontSize: '1.429rem'
    }
  },
  base: {
    display: 'flex',
    flexDirection: 'column'
  }
});

export default styles;
